import React, {useState} from 'react'

import {A} from "./components/A";
import {InfoAndSkills, InfoKey, InfoVal} from "./components/Info";
import { AService } from './components/Aservice';
import { ImgSet, Lightbox } from './components/Lightbox';
import { Section } from './components/Section';




function App() {

  const [state_values, setStateValues] = useState({
    "show_lightbox":false,
    "fading_lightbox":false,
    'lightbox_image_sets':[],
    'lightbox_set_index': 0
  })

  const amEngaged = true;
  const engagementLength = "Indefinite"


  return (
    <div className="App">

    <section id="profile" className="container mx-auto flex min-h-screen lg:min-h-screen text-white">
      <div className="grid grid-cols-1 gap-y-4 lg:grid-cols-3 lg:gap-4 m-auto">

        <div className="bg-green bg-opacity-40 bg-blur p-4 xl:p-8">


            <img src="/assets/pfp.jpg" className="max-w-66 rounded-full block mx-auto my-8" alt="My glamour headshot."/>

            <div className="grid grid-cols-4 gap-0 my-8">

              <InfoKey>Location:</InfoKey>
              <InfoVal>Birmingham, UK</InfoVal>

              <InfoKey>Email: </InfoKey>
              <InfoVal><a href="mailto:robin+site@bitcrush.org">robin@bitcrush.org</a></InfoVal>
              {/* //<!-- scroll to bottom contact form --> */}

              <InfoKey>Experience: </InfoKey>
              <InfoVal>{new Date().getFullYear() - 2011} Years</InfoVal>

              <InfoKey>Freelance: </InfoKey>
              <InfoVal>
                <h4>{amEngaged ? "Engaged - "+engagementLength : "Available!"}</h4>
              </InfoVal>
            </div>

            <InfoAndSkills className="hidden lg:block"/>
          </div>






        <div className="col-span-2 grid grid-cols-1 gap-4">

          <div className="bg-black bg-opacity-20 bg-blur p-4 xl:p-8">

                <p className="lead">
                    I am <b>Robin Hayes</b>, and I make cool websites.
                </p>

                <p>I am passionate and creative, and enjoy broadening my skills into other disciplines to bring my web development work to the next level.</p>

                <p>I am always ready to learn new techniques and principles, to create the most fitting, best possible work for any client.</p>


                <blockquote>
                  I stand by that you are the best developer I've
                  <div className="inline-block">&nbsp;worked with.</div>
                </blockquote>

                <blockquote>
                  We really like you and like working
                  <div className="inline-block">&nbsp;with you</div>
                </blockquote>


                <p>This page is always being tweaked. I designed it around my love of nature - to be friendly, engaging and relaxing, from my belief that tech should always be human-first. The easiest way to code something usually results in awkward UX - but even in the backend, I'm always working with the UX in mind.</p>

                <p>The holy trinity is always my end goal: useful, easy, and fun.</p>

            </div>


            <div className="bg-green bg-opacity-40 bg-blur p-4 lg:hidden">
              <InfoAndSkills/>
            </div>


          <div className="bg-black bg-opacity-20 bg-blur p-4 xl:p-8">

              <h2>Services</h2>

              <p className="lead">
                  {
                    amEngaged
                    ? 'I am currently engaged'
                    : 'I am currently open for full-remote freelance work, preferably around 3 months'
                  }
                  &nbsp;- but&nbsp;
                  <a className="inline-block" href="mailto:robin+site@bitcrush.org">contact me</a>, and let's work something out.
              </p>



              <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 mx-auto">

              <AService
                title="Web Development"
                subtitle="Front, Back and Full-Stack"
                items={[
                  "PHP expertise, including Laravel and Wordpress",
                  "Javascript, including Vue, React, jQuery, and WebGL",
                  "Shopify apps, POS and embedded",
                  "CSS, Tailwind, SASS or LESS, Bootstrap and Foundation",
                  "10+ years of experience"
                ]}
              />

              <AService
                title="Python Programming"
                subtitle="from freelancer import great_work"
                items={[
                  "Optimisation for speed and throughput",
                  "Expertise in UI building with wxWidgets",
                  "Packaging apps/exes with pyinstaller",
                  "\"Compatibility mode\" OpenGL 2, GLSL 1.2",
                  "Server/client TCP networking",
                ]}
              />

              <AService
                title="Music Creation and Sound Design"
                subtitle="Yeah, That Sounds About Right"
                items={[
                  "BA 2:1 in Music Composition",
                  "Baritone voice and mic setup for voiceover work",
                  "Music composed in orchestral, chiptune, pop-rock, folk, hiphop, any genre",
                  "Audio mixing and mastering",
                ]}
              />

              <AService
                title="And The Rest"
                subtitle="How Can I Help?"
                items={[
                  "I'm not too bad at writing approachable copy, and fairly skilled with a more professional tone.",
                  "I can create illustrations and artwork in 3D, pixel, or vector.",
                  "I have experience making games with Unity, modelling with Blender, editing videos with DaVinci Resolve.",
                ]}
              />

            </div>


          </div>





        </div>
      </div>
    </section>






    <Section className="text-white"
      id="threedpe"
      bg="assets/sections/3dpe/bg.jpg"
      tags={["Full Stack", "My Design", "Laravel 6", "Bootstrap", "CSS Animation", "3D Asset Creation"]}
      title="3dPE.org - Full-Stack Site for a Game&nbsp;Engine"
      link="https://3dpe.org/"
      link_text="Visit 3dPE.org"
      >
        <div>
          <p className="lead">An emphasis on creativity and robots.</p>

          <p>In my spare time, I am programming a game engine in Python. The main goal is to provide simple tools that allow anyone to make small and weird games. The site is tailor-made to support the engine.</p>

          <p>The backend is Laravel 6, with the site providing an API for user authentication and project management. It interfaces with the project's git repos to show engine progress, with GitLab to store creators' game projects, and with a Discord server via a node.js bot.</p>

          <p>Each project is provided with a landing page, news announcement system, user management, and a full forum-style message-board.</p>

          <p>The frontend is built using Bootstrap with customised SASS, CSS animations, embedded background video, and various other adjustments.</p>

          <p>The design's main focus is to show a wide range of creativity for game creators, symbolised by broad rainbow colours on a neutral grey backdrop. The branding's red and cyan is to evoke anaglyphic 3D glasses.</p>

          <p>I created the various 3D models in Blender, and the mascot 3bot's retro, loose- (or no-) limbed style is meant to foster a sense of playfulness and fun imperfection.</p>
        </div>
        <div>
          <ImgSet prefix="3dpe" state_values={state_values} setStateValues={setStateValues}>
            <div img="frontpage.jpg">
              <p>The front page is meant to be bold and enticing. The chequerboard of images in the background should fire off the imagination.
                Many of them are animated gifs, with the option to disable them on the bottom right.</p>
              <p>There is also an option to turn off the red/cyan anaglyph effect, on the bottom left when logged out (and in user settings when logged in).</p>
              <p>Under the hero banner is the git ticker, showing recent updates to the game engine and its plugins.</p>
            </div>

            <div img="3dpe19-plugins.gif">
              <p>The base engine is mostly a collection of utilities and a wrapper; the engine's real power comes from its plugins.</p>
              <p>To get the idea across, I decided on this visual of crackling electricity, and these chunky, literal plugs, each containing a little world.</p>
              <p>On the page itself, this animation is a webm movie.</p>
            </div>

            <div img="responsive.jpg">
              <p>The site is fully mobile responsve, mostly thanks to using Bootstrap.</p>
              <p>Even though it's a game engine for desktop, not mobile, eventually I want to develop it into a community hub, and keep it accessible to people checking in on their phones.</p>
            </div>


            <div img="3dpe19-follow.gif,3dpe19-game-create.gif,3dpe19-like.gif,3dpe19-title-anims.gif">
              <p>I used CSS animations in a few places, to make important actions fun and enticing.</p>
              <p>The rainbow glow effect on the text is created with CSS :before and :after selectors, slightly offset and with adjusted font metrics, and a linear gradient background with background-clip:text. It's not perfect, but it gets the point across for now.</p>
            </div>

            <div img="3bot-sketch.png,3bot-waving.gif">
              <p>I commissioned a friend to design 3bot, then I modelled and animated him in Blender, adjusting some proportions for appeal.</p>
              <p>I tried to add personality in the animation - he's not fully robotic, he's happy to see you.</p>
            </div>
          </ImgSet>
        </div>
    </Section>





    <Section className=""
      id="luke"
      bg="assets/sections/luke/bg.jpg"
      tags={["Full Stack", "My Design", "WebGL", "SVG Animation", "Audio Analysis"]}
      title="LukeFreemanPiano.com - JavaScript Portfolio for a Piano Teacher"
      link="https://www.lukefreemanpiano.com/"
      link_text="Visit LukeFreemanPiano.com"
      >
        <div>
          <p className="lead">He can teach you to be this good!</p>

          <p>A dear friend asked me to make him a website, to act as a portfolio, and also to attract students.</p>

          <p>The backend is just HTML, except for a bare PHP contact form.</p>

          <p>The frontend was kept deliberately simple, and the site's background becomes a visualiser for the music pieces. Using colours from the cover art, it uses WebGL to create a slowly shifting background and waveform, and spawn music notes, all controlled directly by the audio file as it plays.</p>

          <p>There is also a bare PHP administration section, where Mr. Freeman can log in and make changes himself, like uploading new pieces. All it takes is an audio file, a cover image, and a title.</p>
        </div>
        <div>

          <ImgSet prefix="luke" state_values={state_values} setStateValues={setStateValues}>
              <div img="front-page.jpg">
                <p>For the display font, I chose a long and straight font to echo a piano keyboard. Client requested blue as the default colour.</p>
                <p>When music is played, the whole page acts like a visualiser, but with the content set above to ensure readability. The effect is kept soft and un-detailed so it doesn't get too distracting.</p>
              </div>

              <div img="luke-vis.gif">
                <p>The bottom bar is an SVG, with the waveform set by the audio. Music notes are created when the volume increases at a set of frequencies.</p>
                <p>The background slowly rotates and shifts colours, speed dependent on the overall volume. The banding shown here is just a GIF artefact.</p>
                <p>The background and the music notes are a WebGL canvas.</p>
              </div>

              <div img="colour-change.jpg">
                <p>All elements change colour to match the current track's artwork. Strong colours are picked using a JavaScript library called <A href="https://github.com/lokesh/color-thief">Color Thief</A> by Lokesh Dhakar.</p>
              </div>

              <div img="contact-cover.jpg">
                <p>The only php element is the contact form, since it sends an email directly to Luke. To save his spam filter, a reCAPTCHA was added.</p>
              </div>

            </ImgSet>
        </div>
    </Section>






    <Section className=""
      id="majestic"
      bg="assets/sections/majestic/bg.jpg"
      tags={["Full Stack", "Laravel 3", "Custom CMS", "Agency Work", "Bootstrap", "CSS Animation"]}
      title="MajesticTowels.co.uk - B2B Online Store"
      link="https://www.majestictowels.co.uk/"
      link_text="Visit MajesticTowels.co.uk"
      >
        <div>
          <p className="lead">Bulletroof Backend while Designing in the Gaps</p>

          <p>I developed this site while working at an agency.</p>

          <p>The brief was to rebuild the client's old website, updating it to be mobile responsive, to improve the product search for customers, and to revisit how stock was tracked.</p>

          <p>There is a CMS system for the client to edit pages, as well as update products. The products are linked to their internal stock database. Payments go through the SagePay gateway.</p>

          <p>The frontend is based around heavily modified Bootstrap. I was given designs for some key pages, and developed everything else myself to match the style.</p>

          <p>Five years later, the website is still going strong.</p>


        </div>
        <div>
          <ImgSet prefix="majestic" state_values={state_values} setStateValues={setStateValues}>
              <div img="filters.jpg">
                <p>I developed an extensive MySQL query system to get the filtering system backend working in perfect sync with the frontend.</p>
                <p>All of the categories are just filter presets.</p>
              </div>

              <div img="search.jpg">
                <p>The search results also allow filtering by the categories and subcategories of the items in the results.</p>
              </div>

              <div img="responsive.jpg">
                <p>Bringing all desktop functionality to mobile devices was the number one goal for this rebuild.</p>
              </div>

              <div img="majestic-basket.gif">
                <p>I tried to keep CSS animations unobtrusive, while still being clear that the basket had been updated. This keeps the friction when purchasing to a minumum.</p>
              </div>

            </ImgSet>
        </div>
    </Section>




    <Section className=""
      id="workspace"
      bg="assets/sections/workspace/bg.jpg"
      tags={["Full Stack", "Wordpress", "Agency Work", "Bootstrap", "Content Management"]}
      title="Workspace-Technology.com - Engineering Company Product Showcase"
      link="https://web.archive.org/web/20170711181631/https://www.workspace-technology.com/"
      link_text="Archived Workspace-Technology.com"
      >
        <div>
          <p className="lead">7 Years, Over 300 Pages - Organised Neatly</p>

          <p>I developed this site while working at an agency.</p>

          <p>Another mobile rebuild, but there was some work to be done first - the original website had been added to monthly for almost a decade, and it wasn't easy for a potential client to find the right product.</p>

          <p>I went through more than three hundred pages, and arranged all the content to match the company's internal divisions.</p>

          <p>After working with a designer to present the pages, divisions and subdivisions as cleanly as possible, I rebuilt the site with a heavily customised Wordpress install, and presented a guide for its use to the Managing Director.</p>


        </div>
        <div>
          <ImgSet prefix="workspace" state_values={state_values} setStateValues={setStateValues}>
              <div img="main.jpg">
                <p>The website has always been absolutely packed with information, so I sorted through all the categories and worked with a designer to lay it out.</p>
                <p>There is aways an element of compromise with the client, and the info they want immediately shown.</p>
              </div>

              <div img="ws-header.gif">
                <p>The MD loved the typing ticker and the info accordion.</p>
              </div>

              <div img="responsive.jpg">
                <p>All content completely mobile responsive</p>
              </div>

              <div img="site-map.jpg">
                <p>The site map, to scale.</p>
              </div>

            </ImgSet>
        </div>
    </Section>










    <Lightbox state_values={state_values} setStateValues={setStateValues}/>
  </div>
  );
}

export default App;
